import React from 'react';

type BoldIconProps = {
  height?: string;
  width?: string;
};

function AlignCenter({ height = '18', width = '18' }: BoldIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 10H3M20 6H3M20 14H3M16 18H3'
        stroke='black'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default AlignCenter;
